import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { OauthService } from 'src/app/services/oauth.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-oauth-callback',
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner],
})
export class OauthCallbackComponent implements OnInit {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private auth = inject(AuthService);
  private oauth = inject(OauthService);
  private snack = inject(MatSnackBar);

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    if (error || !code || !state) {
      this.failAndGoToLogin();
      return;
    }

    this.auth.completeOauthLogin(code, state).subscribe({
      next: (user: User) => {
        const redirect = this.oauth.consumePostLoginRedirect();

        if (redirect) {
          void this.router.navigateByUrl(redirect);
          return;
        }

        if (user.role?.slug === 'worker') {
          void this.router.navigate(['/employees/dashboard']);
          return;
        }

        if (user.role?.slug === 'client') {
          void this.router.navigate(['/clients/company-products']);
          return;
        }

        if (user.role?.slug === 'partner') {
          void this.router.navigate(['/partners/company-products']);
          return;
        }

        void this.router.navigate(['/']);
      },
      error: () => {
        this.failAndGoToLogin();
      },
    });
  }

  private failAndGoToLogin(): void {
    this.snack.open('No se ha podido completar el inicio de sesión', 'Ok', { duration: 4000 });
    this.oauth.clearPkceSession();
    void this.router.navigate(['/auth/login']);
  }
}
